import { IComponentOptions } from "angular";
import { OrderActionsController } from "./order-actions.controller";

/**
 * @type {IComponentOptions}
 */
export const OrderActionsComponent = {
  bindings: {
    print: "&",
    printLote: "&",
    deleteAll: "&",
    showPrint: "=",
    showPrintEmLote: "=",
    showAdd: "=",
    showDelete: "=",
  },
  template: require("./order-actions.html"),
  controller: OrderActionsController,
};
